module.exports = __webpack_public_path__ + "img/danielson_resize.5ee00a1e.jpg";